module.exports = __webpack_public_path__ + "media/images/tour_symbolic-7422e2043e0f094c3015f7b881e04358.jpg";